import React, { PropsWithChildren, createContext, useState } from 'react';

import { AdminPropertyContentResponse, PropertyResponse } from '~/services/AccommodationService';

interface PropertyDetailsState {
  propertyDetails?: PropertyResponse;
  propertyContent?: AdminPropertyContentResponse;
  setPropertyDetails: (propertyDetails: PropertyResponse) => void;
  setPropertyContent?: (propertyContent: AdminPropertyContentResponse) => void;
  /**
   * Refetches the property the page was rendered from. `setPropertyDetails` only updates this
   * context, and the header and layouts render the page's own fetch result, so a save has to
   * refresh that too or they keep showing pre-save values.
   */
  refreshPropertyDetails?: () => void;
}

export const AccommodationPropertyDetailsContext = createContext<PropertyDetailsState>({} as PropertyDetailsState);

interface Props {
  content?: AdminPropertyContentResponse;
  details: PropertyResponse;
  refreshPropertyDetails?: () => void;
}

export function AccommodationPropertyDetailsContextProvider({
  content,
  details,
  refreshPropertyDetails,
  children,
}: PropsWithChildren<Props>) {
  const [propertyDetails, setPropertyDetails] = useState<PropertyResponse>(details);
  const [propertyContent, setPropertyContent] = useState<AdminPropertyContentResponse | undefined>(content);

  return (
    <AccommodationPropertyDetailsContext.Provider
      value={{
        propertyDetails,
        propertyContent,
        setPropertyDetails,
        setPropertyContent,
        refreshPropertyDetails,
      }}
    >
      {children}
    </AccommodationPropertyDetailsContext.Provider>
  );
}

export default AccommodationPropertyDetailsContextProvider;
